import getNamespace from "./getNamespace/";
import isCustomerTranslationEnabled from "./isCustomerTranslationEnabled/";
import useCustomerTranslation from "./useCustomerTranslation";
import getTranslatedValue from "./getTranslatedValue";

export default {
  getNamespace,
  getTranslatedValue,
  isCustomerTranslationEnabled,
  useCustomerTranslation,
};
